import { useSearchParams } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { IconGeneratorForm } from '../components/IconGeneratorForm';
import { IconPreview } from '../components/IconPreview';
import { useIconGenerator } from '../hooks/useIconGenerator';
import { ArcheHeader } from '../../../components/ArcheHeader';

export function IconGeneratorPage() {
  const { status, previewUrl, error, generate, save, reset, attachedIconKey } = useIconGenerator();
  // Arche-builder deep-links here with `?attachTo=arch_xxx` so the form can
  // surface a "Use as my arche icon" button alongside "Save to Files".
  const [searchParams] = useSearchParams();
  const attachToArcheId = searchParams.get('attachTo') ?? undefined;

  return (
    <div className="flex flex-col h-full">
      <ArcheHeader archeId="arche_icon_generator" title="Icon Generator" />
      <div className="p-6 max-w-2xl mx-auto space-y-6 w-full">
        <p className="text-muted-foreground">Generate professional app-store-style icons with AI</p>

        {attachToArcheId && (
          <div className="text-sm rounded-md border border-primary/30 bg-primary/5 px-3 py-2">
            Generating an icon for arche{' '}
            <code className="font-mono text-xs">{attachToArcheId}</code>. When ready, click{' '}
            <strong>Use as my arche icon</strong>.
          </div>
        )}

        <Card>
          <CardHeader>
            <CardTitle className="text-lg">Icon Details</CardTitle>
          </CardHeader>
          <CardContent>
            <IconGeneratorForm
              status={status}
              onGenerate={generate}
              onSave={save}
              onReset={reset}
              attachToArcheId={attachToArcheId}
            />
          </CardContent>
        </Card>

        <IconPreview status={status} previewUrl={previewUrl} error={error} />

        {status === 'saved' && attachedIconKey && (
          <div className="text-sm rounded-md border border-emerald-500/30 bg-emerald-500/5 px-3 py-2 text-emerald-700 dark:text-emerald-400">
            Icon attached to your arche. It may take a moment to appear in the marketplace.
          </div>
        )}
      </div>
    </div>
  );
}
